import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
    renderField,
    renderFieldDateFormat
} from '../../Utils/renderField/renderField';

let initialValues = {};

let PaymentFormIgss = (props) => {
    const {
            handleSubmit,
        } = props;

    const total_cuentas = props.total_cuentas;

    return (
        <form onSubmit={handleSubmit} id="paymentGroup" className="d-flex justify-content-center flex-column flex-sm-row align-items-stretch align-items-sm-center">
            <Field name="cuentas" component={"input"} type="hidden"/>

            <table className="table" id="table-frm-pay-oc">
                <thead></thead>
                <tbody className="oc-body-form">
                    <tr>
                        <th className="oc-custom-table" colSpan={2}>
                            CANTIDAD DE CUENTAS A PAGAR <span fontWeight="bold">{total_cuentas}</span>
                        </th>
                    </tr>
                    <tr>
                        <th>FECHA DE PAGO</th>
                        <td>
                            <Field
                                name="fecha_fac"
                                component={renderFieldDateFormat}
                                type="text"
                                className="form-control oc-input-modal"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>FACTURA DE REFERENCIA</th>
                        <td>
                            <Field
                                name="no_document"
                                component={renderField}
                                type="text"
                                className="form-control oc-input-modal"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    );
}

PaymentFormIgss = reduxForm({
    form: 'paymentGroupIgss',
    initialValues,
    validate: data => {
        const errors={};
        console.log(data.transaction);

        if(!data.no_document){
            errors.no_document = 'Campo requerido';
        }

        return errors;
    }
 })(PaymentFormIgss);

export default PaymentFormIgss;
